export enum BlockingCardStatus {
        Stolen = 0,
        Lost = 1,
        Swallowed = 2,
        Other = 3
}
